import { FileTypeEnum } from "@/constants/enums/fileType.enum";
import { ExpeditionDocumentFileBoDto } from "@/types/api/api-types";

export const filterDocumentsExceptCustomInvoice = (documents: ExpeditionDocumentFileBoDto[]) =>
  documents.filter(
    (d) =>
      d.type !== FileTypeEnum.EXPEDITION_CUSTOM_INVOICE &&
      d.type !== FileTypeEnum.EXPEDITION_CUSTOM_INVOICE_EXCEL,
  );
